export const createObjectUrlForBlob = (data: Blob): string => URL.createObjectURL(data);
